import { useAuthStore } from '../stores/auth-store';
import { useToastStore } from '../stores/toast-store';

import { configureApiClient } from './api-client';
import { resetSessionCache } from './query-client';

/**
 * Liga apiClient ao authStore + toastStore — chamado uma única vez no
 * boot (importado por main.tsx via efeito top-level).
 *
 * apiClient é módulo singleton: lê tokens via getter, escreve via
 * setter, dispara onUnauthorized quando 401 sem refresh válido, dispara
 * onForbidden quando 403 (preserva sessão; toast informa).
 *
 * Item 88 (18/Mai/2026): separação 401 vs 403 — antes ambos forçavam
 * logout, fazendo Carlos perder sessão ao navegar URL direta da Ana.
 * Agora 403 só notifica via toast.
 */
configureApiClient({
  getTokens: () => {
    const s = useAuthStore.getState();
    return { accessToken: s.accessToken, refreshToken: s.refreshToken };
  },
  setTokens: (next) => {
    useAuthStore.getState().setSession(next);
  },
  onUnauthorized: () => {
    useAuthStore.getState().clear();
    // Sessão expirou/invalidou: descarta o server-state cacheado para a próxima
    // sessão (mesmo browser, sem reload) não herdar dados do usuário anterior.
    resetSessionCache();
  },
  onForbidden: ({ body }) => {
    // Compõe descrição com capability/reason ou permission/layer
    // conforme guard. Mantém mensagem principal estável (UX claro).
    const detail =
      body.capability !== undefined && body.capability.length > 0
        ? `${body.capability}${body.reason !== undefined && body.reason.length > 0 ? ` — ${body.reason}` : ''}`
        : body.reason;
    useToastStore.getState().push({
      variant: 'error',
      title: 'Sem acesso a este recurso',
      ...(detail !== undefined && detail.length > 0 && { description: detail }),
    });
  },
});
